import React, { useState, useEffect } from "react";
import { observer } from "mobx-react";
import { BrowserRouter } from "react-router-dom";
// import { BrowserRouter, Route } from "react-router-dom";
import { AppGridWrap, AppContainer, RouteBox } from "./style";
import Header from "../Header";
import SideBar, { MenuList, ShortcutManual } from "../SideBar";
import AppRouter from "../../router/Routes";
import { getServerType } from "../../constants";
import AddOn from "../SideBar/AddOn";
import PrivateRoute from "../../router/PrivateRoute";
import { checkAuth, signOut } from "../../utils/nauth";
import { getTemplateCount } from "../../api/Common";
import { useCookies } from "react-cookie";

// const multiRoute = ({ paths, element: Element, ...rest }: any) =>
//   paths.map((path: string) => {
//     return <Route key={path} path={path} {...rest} element={Element} />;
//   });

const AppView = () => {
  const [isLogin, setIsLogin] = useState(false);
  const [preparing, setPreparing] = useState(0);
  const [cookies, setCookie, removeCookie] = useCookies();
  // eslint-disable-next-line
  useEffect(() => {
    setIsLogin(checkAuth());
    getTemplateCount({}).then((response) => {
      setPreparing(response.totalCount);
    });
    // eslint-disable-next-line
  }, []);
  const headerClickHandler = () => {
    removeCookie("page", { path: "/" });
    removeCookie("startDate", { path: "/" });
    removeCookie("endDate", { path: "/" });
    removeCookie("status", { path: "/" });
    removeCookie("hPage", { path: "/" });
    removeCookie("hStartDate", { path: "/" });
    removeCookie("language", { path: "/" });
    removeCookie("category", { path: "/" });
    window.location.href = "/";
  };
  return (
    <BrowserRouter>
      <AppGridWrap>
        <Header
          label="KineMaster Console :: Template"
          server={getServerType()}
          isLogin={isLogin}
          logoutHandler={signOut}
          onClick={headerClickHandler}
        />
        <AppContainer>
          <SideBar menuList={MenuList}>
            <AddOn count={preparing} />
            <br />
            <br />
            <br />
            <ShortcutManual />
          </SideBar>

          <RouteBox>
            <PrivateRoute>
              <AppRouter />
            </PrivateRoute>
          </RouteBox>
        </AppContainer>
      </AppGridWrap>
    </BrowserRouter>
  );
};

export default observer(AppView);
